import styled from 'styled-components';

export const BillingWrapper = styled.div`
  font-family: 'Inter', sans-serif !important;
  
  /* Ensure all child elements inherit the Inter font */
  * {
    font-family: 'Inter', sans-serif !important;
  }
  
  /* Override any Material-UI components that might have their own font */
  .MuiTypography-root,
  .MuiButton-root,
  .MuiCard-root,
  .MuiChip-root,
  .MuiDialog-root {
    font-family: 'Inter', sans-serif !important;
  }
    .billing-heading-container{
    margin-bottom: 32px;
    
    @media (max-width: 600px) {
      margin-bottom: 24px;
    }
    }
   .billing-heading{
    font-size: ${({ theme }) => theme["nt-text-h1"]};
    font-weight: ${({ theme }) => theme["bold-weight"]};
    margin-bottom: 8px;
    line-height: 36px;
    
    @media (max-width: 600px) {
      font-size: 1.75rem;
      line-height: 32px;
      margin-bottom: 6px;
    }
   }
    .billing-sub-heading{
    font-size: ${({ theme }) => theme["nt-text-base"]};
    font-weight: ${({ theme }) => theme["normal-weight"]};
    margin-bottom: 24px;
    color: ${({ theme }) => theme["body-text-color"]};
    line-height: 24px;
    margin-bottom: 0px;
    
    @media (max-width: 600px) {
      font-size: 0.875rem;
      line-height: 20px;
    }
    }
    .billing-card{
    border: none;
    border-radius: 8px;
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.08);
-webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.08);
-moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.08);
    }
    .billing-card-header{
        padding: 16px;
        gap: 8px;
        
        @media (max-width: 600px) {
          padding: 12px;
        }
        
        .MuiCardHeader-avatar {
            margin-right: 0;
            svg{
                height: 20px;
                width: 20px;
            }
        }
        .MuiCardHeader-content > span{
            font-size: ${({ theme }) => theme["nt-text-h4"]};
            font-weight: ${({ theme }) => theme["bold-weight"]};
            
            @media (max-width: 600px) {
              font-size: 1rem;
            }
        }
    }  
    .billing-card-content{
        padding: 0 16px 16px 16px;
        
        @media (max-width: 600px) {
          padding: 0 12px 12px 12px;
        }
        
        .billing-card-header-title{
            font-size: ${({ theme }) => theme["nt-text-h3"]};
            font-weight: ${({ theme }) => theme["bold-weight"]};
            
            @media (max-width: 600px) {
              font-size: 1.125rem;
            }
        }
    }
    .billing-card-header-chip{
        background-color: #dbeafe;
        border: 1px solid #bfdbfe;
        color: #1e41af;
        font-size: ${({ theme }) => theme["nt-text-h6"]};
        text-transform: capitalize;
        height: 20px;
        font-weight: ${({ theme }) => theme["bold-weight"]};
        padding: 2px;
        &.MuiChip-outlinedSuccess{
            background-color: #dcfce8;
            color: #166534;
            border-color: #bcf7d0;
        }
        &.MuiChip-outlinedError{
            background-color:rgb(252, 220, 220);
            color:rgb(101, 22, 22);
            border-color:rgb(247, 188, 188);
        }
    }
    .billing-card-button{
        background-color: #fff;
        border-color: #e2e8f0;
        text-transform: capitalize;
        padding: 6px 12px;
        letter-spacing: normal;
        white-space: nowrap;
        border-radius: 6px;
        font-size: ${({ theme }) => theme["nt-text-h5"]};
        font-weight: ${({ theme }) => theme["semi-bold-weight"]};
        
        @media (max-width: 600px) {
          padding: 8px 16px;
          font-size: 0.875rem;
        }
    }
    .billing-records-table{
        border: none;
        .ag-header-row{
            background-color: #fff;
        }
        .ag-row{
            border-color: #e2e8f0;
        }
        .ag-header-cell{
            .ag-header-cell-label{
                font-size: ${({ theme }) => theme["nt-text-h5"]};
                padding: 16px;
            }
            .ag-header-cell-text{
                color: #64748b;
            }
            &::after{
                display: none;
            }
        }
        .ag-cell{
            .ag-cell-value{
                padding: 16px;
            }
        }
        .ag-cell-value{
            color: #000 !important;
        }
        .billing-table-id{
            font-family: "Space Mono", monospace !important;
  font-weight: 500;
  line-height: 20px;
        }
    }
    .billing-pagination{
        background-color: #fff;
    }
`;  
